import { render, staticRenderFns } from "./CustomAudit.vue?vue&type=template&id=552b17bb&scoped=true&"
import script from "./CustomAudit.vue?vue&type=script&lang=js&"
export * from "./CustomAudit.vue?vue&type=script&lang=js&"
import style0 from "./CustomAudit.vue?vue&type=style&index=0&id=552b17bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552b17bb",
  null
  
)

export default component.exports